import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.jobSecurity.aiTransformation',
    value: 'ai-transformation',
  },
  {
    title: 'pages.onboarding.jobSecurity.tasksByAi',
    value: 'tasks-by-ai',
  },
  {
    title: 'pages.onboarding.jobSecurity.newHires',
    value: 'new-hires',
  },
  {
    title: 'pages.onboarding.jobSecurity.restructuring',
    value: 'restructuring',
  },
  {
    title: 'pages.onboarding.jobSecurity.colleaguesAi',
    value: 'colleagues-ai',
  },
  {
    title: 'pages.onboarding.jobSecurity.budgetShift',
    value: 'budget-shift',
  },
  {
    title: 'pages.onboarding.jobSecurity.none',
    value: 'none',
  },
]

export default function JobSecurityPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      multiple
      title="pages.onboarding.jobSecurity.title"
      subtitle="pages.onboarding.jobSecurity.subtitle"
    />
  )
}
